import React, { useEffect, useState } from "react";

import { commaizeFloat } from "../../Common";
import ReferModal from "../../Common/components/Modals/ReferModal";
import { Table,Tabs, Switch, Popover, Button, Modal, Tooltip, Input, Select,Row,Col, Divider} from 'antd';

import Lenders from "../../Management/Lenders";
import { checkAccess } from "../../Auth";
import { UR_Owner, UR_LoanOfficer, UR_PriceEngineUser } from "../../State";
import * as com from "../../Common";
import FullScreenModal from "../../Common/components/FullHeightModal";
import MortgageGPT from "../../MortgageGPT";
import { useSelector, useDispatch } from 'react-redux'
import { CONTENT_TYPES } from '../../MortgageGPT/constants'
import ClosingCostFeeModal from "./components/ClosingCostFeeModal";

const typemap = {
  fixed30: "30 Year",
  fixed25: "25 Year",
  fixed20: "20 Year",
  fixed15: "15 Year",
  fixed10: "10 Year",
  arm56: "ARM 5/6",
  arm76: "ARM 7/6",
  arm106: "ARM 10/6",
}

const getMaxPriceCap = (rate) => {
  const rawCapPoints = rate?.maxPriceCap;
  const capPoints = Number(rawCapPoints) || 0;
  const hasMaxPriceCap = rawCapPoints != null;
  return { capPoints, hasMaxPriceCap };
}

export default function PricingResults(props) {

  const [allresults,setAllResults] = useState(0);
  const [connectedresults,setConnectedResults] = useState(0);
  const [activeTabKey, setActiveTabKey] = useState("fixed30");
  const [currentTarget,setCurrentTarget] = useState('price');
  // const [targetprice,setTargetPrice] = useState(3000);
  const [targetrate,setTargetRate] = useState(6.5);
  const [showAddLenderModal, setShowAddLendersModal] = useState(false);
  const [useDiscountFormat, setUseDiscountFormat] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showShareRateModal, setShowShareRatesModal] = useState(false);
  const [showAskAIModal, setShowAskAIModal] = useState(false);
  const [showClosingCostModal, setShowClosingCostModal] = useState(false);
  const [selectedLoanForModal, setSelectedLoanForModal] = useState(null);
  const [updatedOriginationArr, setUpdatedOriginationArr] = useState([]);
  const [showReferModal, setShowReferModal] = useState(false);

  const { TextArea } = Input;

  // Helper function to calculate closing costs from API data
  const getClosingCostDetails = (calculatedLenderOriginationFee, lender, brokerComp) => {
    const calculateArrayTotal = (arr) => {
      if (!arr || !Array.isArray(arr)) return 0;
      return arr.reduce((sum, item) => sum + (Number(item.estimateAmount) || 0), 0);
    };


    const originationCharges = calculateArrayTotal(props.closingFeeConfig?.originationCharges);
    let finalOriginationFee = calculatedLenderOriginationFee >= originationCharges ? calculatedLenderOriginationFee : originationCharges;
    const canNotShopServices = calculateArrayTotal(props.closingFeeConfig?.canNotShopServices);
    const canShopServices = calculateArrayTotal(props.closingFeeConfig?.canShopServices);
    const taxesAndOtherGovernmentFees = calculateArrayTotal(props.closingFeeConfig?.taxesAndOtherGovernmentFees);
    const prepaids = calculateArrayTotal(props.closingFeeConfig?.prepaids);
    const initialEscrowPaymentsAtClosing = calculateArrayTotal(props.closingFeeConfig?.initialEscrowPaymentsAtClosing);
    const other = calculateArrayTotal(props.closingFeeConfig?.other);
    const brokerCommission = lender.toLowerCase().includes("thunderbird") ? brokerComp : 0;

    let totalLoanCosts = finalOriginationFee + canNotShopServices + canShopServices;
    if (lender.toLowerCase().includes("thunderbird")){
      finalOriginationFee = finalOriginationFee + brokerCommission;
      totalLoanCosts = totalLoanCosts + brokerCommission;
    }
    const totalOtherCosts = taxesAndOtherGovernmentFees + prepaids + initialEscrowPaymentsAtClosing + other;
    const totalClosingCosts = totalLoanCosts + totalOtherCosts;

    return {
      originationCharges:finalOriginationFee,
      canNotShopServices,
      canShopServices,
      taxesAndOtherGovernmentFees,
      prepaids,
      initialEscrowPaymentsAtClosing,
      other,
      brokerCommission,
      totalLoanCosts,
      totalOtherCosts,
      totalClosingCosts
    };
  };

  const dispatch = useDispatch()
  
  let AllresultsCount={}
  let ConnectedresultsCount={}
  useEffect(() => {
    setAllResults(AllresultsCount[activeTabKey]);
    setConnectedResults(ConnectedresultsCount[activeTabKey])
  }, [activeTabKey,props.productTypes])


  const getCurrentDate = () =>{
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    var today = new Date();

    const dayOfWeek = today.getDay();
    if (dayOfWeek === 0 || dayOfWeek === 6) {
      // If today is Sunday (0), subtract 2 days to get Friday
      // If today is Saturday (6), subtract 1 day to get Friday
      today = new Date(today.getFullYear(), today.getMonth(), today.getDate() - (dayOfWeek === 0 ? 2 : 1));
    }

    return today.toLocaleDateString("en-US", options);
  }

  const AppendOriginationInfoForThunderbird = (record) => {
    let updateOriginationFeeArr = []
    if (record.Lender.toLowerCase().includes("thunderbird")){
      updateOriginationFeeArr.push({
        constactInfo: "",
        estimateAmount: record.prices.compensationPoint * record.loanAmount*0.01,
        identifiedProvider: "",
        serviceName: "Broker commission",
      })
    }
    updateOriginationFeeArr.push({
      constactInfo: "",
      estimateAmount: record.lender_fee,
      identifiedProvider: "",
      serviceName: "Lender origination fee",
    })
    return updateOriginationFeeArr
  }

 const maincolumns = [
    {
      title: 'Lender programs',
      dataIndex: 'program',
      key: 'program',
      width:"150px",
      className: "outerRateColumn",
      render:(_,record)=>(
        <Tooltip
        placement="topLeft"
          title={
            <div>
              <div><strong>{com.formatLenderDisplayName(record.Lender)}</strong></div>
              <div><strong style={{fontSize:"12px"}}>{record.Name}</strong></div>
              <div style={{fontSize:"10px", color:"#white",marginTop:"5px"}}>{`Last Updated on ${getCurrentDate()} 09:00`}</div>
            </div>
          }
        >
          <div>
            <Row><strong style={{fontSize:"16px"}}>{com.formatLenderDisplayName(record.Lender)}</strong></Row>
            <Row>{record.Name}</Row>
            {record.Lender.toLowerCase().includes("thunderbird") && <Row><Button type="primary" onClick={()=>setShowReferModal(true)}>Sign up with this lender</Button></Row>}
          </div>
        </Tooltip>
      ),
      sorter:(a, b) => a.program.localeCompare(b.program),
      sortDirections: ['descend','ascend','descend'],
    },

    {
      title: 'Rate',
      dataIndex: 'rate',
      key: 'rate',
      width:"70px",
      className: "outerRateColumn",
      render:(_,record)=>(
        <>
          <strong style={{color:currentTarget==='rate' && record.isConnected ?"#1677FF":''}}>{record.rate.toFixed(3)}%</strong>
        </>
      ),
      sorter:(a, b) => {
          return a.rate - b.rate;
      },
      sortDirections: ['ascend','descend',"ascend"],
    },
    {
      title: 'Monthly payment',
      dataIndex: 'monthlypay',
      key: 'monthlypay',
      width:"90px",
      className: "outerRateColumn",
      render:(_,record)=>(
        <div>
          <strong>${commaizeFloat(record.monthlypay)}</strong>
          {record.isConnected && <div style={{fontSize:"12px",color: com.divideStringByCapitalLetter(record.Lender) === "GMCC Celebrities" && record.dti.toFixed(0) > 45 ?"#C21818":"#6E6E70",fontWeight:"500"}}>Final DTI : {record.dti.toFixed(0)} %</div>}
        </div>
      ),
      sorter:(a, b) => a.monthlypay - b.monthlypay,
      sortDirections: ['descend','ascend','descend'],
    },
    {
      title: <Tooltip title="The adjusted price is calculated by adding the price adjustment points to the lock day price.">Total pricing</Tooltip>,
      dataIndex: 'originalprice',
      key: 'originalprice',
      width:"130px",
      className: "outerRateColumn",
      render:(_,record)=>{
        let adjustedPrice = useDiscountFormat ? parseFloat(record.originalprice).toFixed(3) +"%" : (100 - parseFloat(record.originalprice)).toFixed(3)
        return <Popover content={record.popoverContent} title=''>
          <div style={{display:"flex",alignItems:"center"}}>
            <strong style={{textDecoration:"underline",color: !record.isConnected?"":record.originalprice<=0 ? "#208029": "#C21818"}} >
              {adjustedPrice} / ${commaizeFloat(parseFloat(record.originalprice * record.loanAmount*0.01).toFixed(0))}
            </strong> 
          </div>
        </Popover>
      },
      sorter:(a, b) => a.originalprice - b.originalprice,
      sortDirections: ['descend','ascend','descend'],
    },
    {
      title: <Tooltip title='The lender price compensation or the broker price compensation'>LPC/BPC</Tooltip>,
      dataIndex: 'compensationprice',
      key: 'compensationprice',
      width:"110px",
      className: "outerRateColumn",
      render:(_,record)=>(
        <strong>
          {record.isConnected ? 
            (
              !record.Lender.toLowerCase().includes("thunderbird") ?
                record.prices.compensationPoint.toFixed(3) + "% / $"+commaizeFloat(record.compensationprice) 
                :
                <>
                <div>-</div>
                <div style={{color: "#6E6E70", fontSize: "12px", fontWeight: "500"}}>Paid at closing</div>
                </>
            )
            : 
            "---"
          }
        </strong>
      ),
      sorter:(a, b) => a.compensationprice - b.compensationprice,
      sortDirections: ['descend','ascend','descend'],
    },

    {
      title: <Tooltip title='The total price is the sum of the lock day price, adjustment points, and compensation points.'>Net pricing</Tooltip>,
      dataIndex: 'points',
      key: 'points',
      width:"120px",
      className: "outerRateColumn",
      render:(_,record)=>{
        let p = useDiscountFormat ? parseFloat(record.FHAMIP ? record.points + (100*record.FHAMIP.upfrontMIP/record.loanAmount) : record.points).toFixed(3) + "%" : parseFloat(100 - (record.FHAMIP ? record.points + (100*record.FHAMIP.upfrontMIP/record.loanAmount) : record.points)).toFixed(3)
        let price = record.FHAMIP ? (record.lender_credit + record.FHAMIP.upfrontMIP) : record.lender_credit
        return <>
          {record.isConnected? <div>
            <Popover content={record.netpricingPopContent} title=''>
              <div style={{display:"flex",alignItems:"center"}}>
                {
                  !record.Lender.toLowerCase().includes("thunderbird") ?
                    <strong style={{textDecoration:"underline",color: record.lender_credit<=0 ? "#208029":"#C21818"}}>
                      {p+" / $"+com.commaizeFloat(price.toFixed(0))}
                    </strong>
                  :
                  <strong style={{textDecoration:"underline",color: "#208029"}}>
                    100.000 / $0
                  </strong>
                }
              </div>
            </Popover>
            <div style={{fontSize:"12px",color:"#6E6E70",fontWeight:"500", cursor:"pointer"}} 
                 onClick={() => {
                   setSelectedLoanForModal(record);
                   setShowClosingCostModal(true);
                    setUpdatedOriginationArr(AppendOriginationInfoForThunderbird(record))
                 }}
            >
              Est. Closing cost: ${com.commaizeFloat(getClosingCostDetails(record.lender_fee, record.Lender, record.prices.compensationPoint*record.loanAmount*0.01).totalClosingCosts)} 
              <span style={{textDecoration:"underline", marginLeft:"4px"}}>View Details</span>
            </div>
          </div>
          :
          <div>---</div>
          }</>
      },
      sorter:(a, b) => {
        if (a.points !== b.points){
          return a.points - b.points;
        } else {
          return a.rate - b.rate;
        }
      },
      defaultSortOrder: 'ascend',
      sortDirections: ['ascend','descend','ascend'],
    },
    // {
    //   title: '',
    //   key: 'share',
    //   align: "center",
    //   width:"30px",
    //   render: (_, record) => (
    //     checkAccess([UR_Owner]) && !record.isConnected ? <div><img src="/images/priceengine/addLendersIcon.png" onClick={()=>setShowAddLendersModal(true)} style={{cursor: "pointer", width:32}} /></div> : ""
    //   ),
    // },
    Table.EXPAND_COLUMN,
  ];
  
  const innerColumns=[
    {
      title: 'Rate',
      dataIndex: 'rate',
      key: 'rate',
      width:"60px",
      className: "innerRateColumn",
      sorter:(a, b) => a.rate - b.rate,
      sortDirections: ['descend','ascend','descend'],
      defaultSortOrder: 'ascend',
      render:(_,record)=>(
        <>
         <strong >{record.rate}%</strong>
        </>
      ),
    },
    {
      title: 'PMT',
      dataIndex: 'monthlypay',
      key: 'monthlypay',
      width:"90px",
      className: "innerRateColumn",
      render:(_,record)=>(
        <div>
          <strong >${commaizeFloat(record.monthlypay)}</strong>
          <div style={{fontSize:"12px",color: com.divideStringByCapitalLetter(record.Lender) === "GMCC Celebrities" && record.dti.toFixed(0) > 45 ?"#C21818":"#6E6E70",fontWeight:"500"}}>Final DTI : {record.dti.toFixed(0)} %</div>
        </div>
      ),
    },
    {
      title: 'Total pricing',
      dataIndex: 'originalprice',
      key: 'originalprice',
      width:"150px",
      sorter:(a, b) => a.originalprice - b.originalprice,
      sortDirections: ['descend','ascend','descend'],
      className: "innerRateColumn",
      render:(_,record)=>{
        let adjustedPrice = useDiscountFormat ? parseFloat(record.originalprice).toFixed(3) +"%" : (100 - parseFloat(record.originalprice)).toFixed(3)
        return <Popover content={record.popoverContent} title=''>
            <div style={{display:"flex",alignItems:"center"}}>
              <strong style={{textDecoration:"underline",color: !record.isConnected?"": record.originalprice<=0 ? "#208029": "#C21818"}} >
                {adjustedPrice} / ${commaizeFloat(parseFloat(record.originalprice * record.loanAmount*0.01).toFixed(0))}
              </strong>
            </div>
        </Popover>
      },
    },
    {
      title: 'LO Comp.',
      dataIndex: 'compensationprice',
      key: 'compensationprice',
      width:"130px",
      className: "innerRateColumn",
      render:(_,record)=>(
        <strong>
          {
            record.isConnected ?
              !record.Lender.toLowerCase().includes("thunderbird") ?
                record.prices.compensationPoint.toFixed(3) + "% / $"+commaizeFloat(record.compensationprice)
                :
                <>
                <div>-</div>
                <div style={{color: "#6E6E70", fontSize: "12px", fontWeight: "500"}}>Paid at closing</div>
                </>
              :
              "---"
          }
        </strong>
      ),
    },
    {
      title: <Tooltip title='The total price is the sum of the lock day price, adjustment points, and compensation points.'>Net pricing</Tooltip>,
      dataIndex: 'points',
      key: 'points',
      width:"130px",
      className: "innerRateColumn",
      render:(_,record)=>{
        let p = useDiscountFormat ? parseFloat(record.FHAMIP ? record.points + (100*record.FHAMIP.upfrontMIP/record.loanAmount) : record.points).toFixed(3) + "%" : parseFloat(100 - (record.FHAMIP ? record.points + (100*record.FHAMIP.upfrontMIP/record.loanAmount) : record.points)).toFixed(3)
        let price = record.FHAMIP ? (record.lender_credit + record.FHAMIP.upfrontMIP) : record.lender_credit
        return <>
        {record.isConnected?
          <Popover content={record.netpricingPopContent} title=''>
            <div>
              <div style={{display:"flex",alignItems:"center"}}>
                {
                  !record.Lender.toLowerCase().includes("thunderbird") ?
                    <strong style={{textDecoration:"underline",color: record.lender_credit<=0 ? "#208029":"#C21818"}}>
                      {!record.isConnected ? "---":  p+" / $"+com.commaizeFloat(price.toFixed(0))}
                    </strong>
                  :
                  <strong style={{textDecoration:"underline",color: "#208029"}}>
                    100.000 / $0
                  </strong>
                }
              </div>
              <div style={{fontSize:"12px",color:"#6E6E70",fontWeight:"500", cursor:"pointer"}}
                   onClick={() => {
                     setSelectedLoanForModal(record);
                     setShowClosingCostModal(true);
                     setUpdatedOriginationArr(AppendOriginationInfoForThunderbird(record))
                   }}
              >
                Est. Closing cost: ${com.commaizeFloat(getClosingCostDetails(record.lender_fee, record.Lender, record.prices.compensationPoint*record.loanAmount*0.01).totalClosingCosts)}
                <span style={{textDecoration:"underline", marginLeft:"4px"}}>View Details</span>
              </div>
            </div>
          </Popover>
          :
          <div>---</div>
        }</>
      },
      sorter:(a, b) => a.points - b.points,
      sortDirections: ['descend','ascend','descend'],
    },
  ]

  const ineligiblecolumns = [
    {
      title: 'Lender',
      dataIndex: 'lender',
      key: 'lender',
      width:"90px",
      className: "ineligibleColumn",
      render:(_,record)=>(
        <div>
          <strong>{com.formatLenderDisplayName(record.Lender)}</strong>
        </div>
      ),
    },
    {
      title: 'Ineligible reason',
      dataIndex: 'reason',
      key: 'reason',
      className: "ineligibleColumn",
      width:"200px",
      render:(_,record)=>(
        <div>
          <div className="d-flex"><strong className="mr-2">Lender level problems:</strong> {record.LenderLevelReason?record.LenderLevelReason:"N/A"}</div>
          <div className="d-flex flex-column">
            <strong className="mr-2">Product level problems:</strong> 
            {record.ProductLevelReasons && record.ProductLevelReasons.map((reason)=>{
            return <ul style={{paddingLeft: "20px"}}>
              <li>{reason.ProductName} - {reason.IneligibleReason}</li>
              </ul>
          })}
          </div>
        </div>
      ),
    },
  ]

  const calcTargetPricing = (data) => {
    let target = 0
    if (props.targetOptions.includes("lockpoint")) {
      target += data.lockDayPoint
    }
    if (props.targetOptions.includes("adjustment")) {
      target +=  data.adjustmentPoint
    }
    if (props.targetOptions.includes("compensation")) {
      target +=  data.compensationPoint
    }
    return parseFloat(target.toFixed(3))
  }

  let mtypes = [];
  let lenderSet = {}
  let lenderRates={}
  let lenderPrices={}
  let ineligibles = []
 
  for (let [name, value] of Object.entries(props.ineligibleProducts)) {
    // Only surface ineligible reasons for connected lenders.
    if (props.connectedLendersMap[name]) {
      ineligibles.push({
        Lender: name,
        ProductLevelReasons: value.ProductLevelReasons,
        LenderLevelReason: value.LenderLevelReason
      })
    }
  }
  
  for (let mtype in props.allRates) {
    for (let d of props.allRates[mtype]){
      let tmpname= d.Lender+' - '+d.Name
      if (typeof(lenderRates[tmpname]) === "undefined"){
        lenderRates[tmpname]=[]
        lenderPrices[tmpname]=[]
     
      }
      // for finding targeting price
      lenderRates[tmpname].push(d.base_rate);
      lenderPrices[tmpname].push(calcTargetPricing(d.prices));
    }
    mtypes.push(mtype)
    if (typeof lenderSet[mtype] === "undefined") {
      lenderSet[mtype] = new Set()
    }
    
    for (let d of props.allRates[mtype]) {
      lenderSet[mtype].add(d.Lender + "-" + d.Name);
    }
  }

  for (let m in lenderSet) {
    lenderSet[m] = Array.from(lenderSet[m]).sort((a, b) => {
      return a.toLowerCase().localeCompare(b.toLowerCase());
  })
  }

  const compareTarget=(target,v,targettype,pname)=>{
    if(targettype === "rate"){
      let differences=lenderRates[pname].map(element=>Math.abs(element-target));
      let minval=Math.min(...differences);
      let minidx = differences.indexOf(minval);
      return v === lenderRates[pname][minidx]
    }
    if(targettype === "price"){
      let differences=lenderPrices[pname].map(element=>Math.abs(element-target));
      let minval=Math.min(...differences);
      let minidx = differences.indexOf(minval);
      return v === lenderPrices[pname][minidx];
    }
  }

  const generateTableData = (ratesData, mtype,targettype) => {
    let tmpOuttableonRate = [];
    let tmpOuttableonPrice = [];
    let tmpIntable={}
    let idx=1;
    for (let d of ratesData){
      let mindiff=false
      let tmpname= d.Lender+' - '+d.Name
      let isConnected = (props.connectedLendersMap[d.Lender] && props.connectedLendersMap[d.Lender] === true )? true : false

      if (typeof(tmpIntable[tmpname]) === "undefined"){
        tmpIntable[tmpname]=[]
      }
      let adjs=[]
      for (let adj in d.Adjustments){
        let i = adjs.length
        adjs.push(
          <div className="d-flex justify-content-between" style={{fontSize: 12, color:"rgb(148 148 148)"}}>
            <div className="d-flex">
              <div style={{width:20}}>{i!=0?"+":""}</div>
              <div>{adj}</div>
            </div>
            <div>{parseFloat(d.Adjustments[adj]).toFixed(3)}%</div>
          </div>
        )
      }
      let beforeCap = d.prices.lockDayPoint + d.prices.adjustmentPoint
      // Max Price caps the rebate (price floor); only pull the price down to it
      // when the natural price would carry more rebate.
      const { capPoints, hasMaxPriceCap } = getMaxPriceCap(d)
      let cappedPrice = (hasMaxPriceCap && beforeCap < capPoints) ? capPoints : beforeCap
      let originalprice = parseFloat(cappedPrice).toFixed(3)
      let Content=(
        <div className="pointsBreakdown">
          <div className="bold mb-2">Adjusted price calculation</div>
          {adjs}
          <hr />
          <div className="d-flex justify-content-between">
            <div className="ml-3">Total adjustment points</div>
            <div>{parseFloat(d.prices.adjustmentPoint).toFixed(3)}%</div>
          </div>
          <div className="d-flex justify-content-between">
            <div>{"+   Lock day points"}</div>
            <div>{parseFloat(d.prices.lockDayPoint).toFixed(3)}%</div>
          </div>
          {hasMaxPriceCap && (
            <>
              <hr/>
              <div className="d-flex justify-content-between">
                <div>Before Max Price</div>
                <div>{parseFloat(beforeCap).toFixed(3)}%</div>
              </div>
              <div className="d-flex justify-content-between">
                <div>Max Price</div>
                <div>{capPoints.toFixed(3)}%</div>
              </div>
            </>
          )}
          <hr/>
          <div className="d-flex justify-content-between">
            <div>Total</div>
            <div>{originalprice}%</div>
          </div>
        </div>
      )

      let netpricingContent = (
        <div style={{padding:"15px 10px"}}>
          <div className="mb-4" style={{fontWeight:"500"}}>Net pricing Calculation:</div>
          <div>Total pricing:  {originalprice}% / ${commaizeFloat(parseFloat(originalprice * d.loanAmount*0.01).toFixed(0))}</div>
          {
            !d.Lender.toLowerCase().includes("thunderbird") ?
            <div>Compensation:  {d.prices.compensationPoint.toFixed(3)}% / ${commaizeFloat(parseFloat(d.prices.compensationPoint * d.loanAmount*0.01).toFixed(0))}</div>
            :
            <div>Compensation:  Paid at closing</div>
          }
          <hr/>
          {
            !d.Lender.toLowerCase().includes("thunderbird") ?
            <div>Net pricing:  { d.points.toFixed(3)}% / ${commaizeFloat(parseFloat(d.points * d.loanAmount*0.01).toFixed(0))}</div>
            :
            <div>Net pricing:  0.000% / $0</div>
          }
        </div>
      )
      
      if(targettype==="rate" && compareTarget(targetrate,d.base_rate,targettype,tmpname)){
        tmpOuttableonRate.push({
          key:idx, 
          isConnected: isConnected,
          program:tmpname,
          rate: d.base_rate,
          price: parseFloat(d.lender_credit).toFixed(0),
          originalprice: originalprice,
          compensationprice: parseFloat(d.prices.compensationPoint).toFixed(0),
          monthlypay: d.monthly_payment,
          dti: d.DTI,
          popoverContent:Content,
          netpricingPopContent:netpricingContent,
          fhamip: d.FHAMIP,
          pricedetails: d.prices,
          adjustments:d.Adjustments,
          ...d,
        })
        idx+=1;
        mindiff=true;
      }

  
      if(targettype==="price" && compareTarget(100 - parseFloat(props.targetPrice), calcTargetPricing(d.prices),targettype,tmpname)){
        tmpOuttableonPrice.push({
          key:idx, 
          isConnected: isConnected,
          program:tmpname,
          rate: d.base_rate,
          price: parseFloat(d.lender_credit).toFixed(0),
          originalprice: originalprice,
          compensationprice: parseFloat(d.prices.compensationPoint * d.loanAmount/100).toFixed(0),
          monthlypay: d.monthly_payment,
          dti: d.DTI,
          popoverContent:Content,
          netpricingPopContent:netpricingContent,
          fhamip: d.FHAMIP,
          pricedetails: d.prices,
          adjustments:d.Adjustments,
          ...d,
        })
        idx+=1;
        mindiff=true;
      }
      tmpIntable[tmpname].push({
        program:tmpname,  
        pricedetails: d.prices,
        isConnected: isConnected,
        rate: d.base_rate,
        price: parseFloat(d.lender_credit).toFixed(0),
        originalprice: originalprice,
        compensationprice: parseFloat(d.prices.compensationPoint * d.loanAmount/100).toFixed(0),
        monthlypay:parseFloat(d.monthly_payment).toFixed(0),
        dti: d.DTI,
        isMin:mindiff,
        popoverContent:Content,
        netpricingPopContent:netpricingContent,
        fhamip: d.FHAMIP,
        ...d,
      })
      
    }

    tmpOuttableonPrice = tmpOuttableonPrice.filter( d => props.selectedlenders.includes(d.program.split(" - ")[0]) )
    tmpOuttableonPrice.sort((a,b)=>a.base_rate-b.base_rate);
    if (targettype==="rate"){
      return [tmpOuttableonRate,tmpIntable];
    }
    if (targettype==="price"){
      return [tmpOuttableonPrice,tmpIntable];
    }
  }
  
  let all={}
  let outdata={}
  let minRate=0;
  const tabdata=[];
  let idx=1;  
  

  for(let mtype in props.allRates){
    [outdata[mtype],all[mtype]]=generateTableData(props.allRates[mtype],mtype,currentTarget);
    AllresultsCount[mtype]=outdata[mtype].length
    ConnectedresultsCount[mtype]=outdata[mtype].filter(d => d.isConnected).length
    if (outdata[mtype].length > 0) {
      minRate = outdata[mtype][0].base_rate
      outdata[mtype]=[]
      all[mtype] = Object.fromEntries(
        Object.entries(all[mtype]).filter(([key, value]) => 
            props.selectedlenders.includes(key.split(" - ")[0])
        )
      );
      let indx = 1;
      for (let key of Object.keys(all[mtype])){
        let d = all[mtype][key]
        let sample = d.find( ele => ele.rate === minRate)
        if (sample !== undefined){
          outdata[mtype].push({
            key:indx,
            ...sample
          })
        }
        else{
          let results = d.filter(ele => ele.rate > minRate)
          let minObj = results.reduce((min, obj)=> obj.rate < min.rate ? obj : min, results[0])
          outdata[mtype].push({
            key:indx,
            ...minObj
          })
        }
        indx+=1
      }
      AllresultsCount[mtype]=outdata[mtype].length
      ConnectedresultsCount[mtype]=outdata[mtype].filter(d => d.isConnected).length
    }
    tabdata.push({
      tabTitle:typemap[mtype],
      intabledata: all[mtype],
      outtabledata:outdata[mtype],
      tabkey:mtype
    })
    idx+=1
  }
  
  let targetTab = tabdata.find(tab=>tab.tabkey===props.loanterm)
  const mapIncomeDocType = (incomeDocTypes) => {
    let docs = []
    for (let doc of incomeDocTypes){
      if (doc === "VOE") {
        docs.push("VOE")
      } else if (doc === "VOE24Mo") {
        docs.push("2-Year VOE")
      } else if (doc === "PersonalBankStatement12Mo") {
        docs.push("1-Year personal bank statement")
      } else if (doc === "PersonalBankStatement24Mo") {
        docs.push("2-Year personal bank statement")
      } else if (doc === "BusinessBankStatement12Mo") {
        docs.push("1-Year business bank statement")
      } else if (doc === "BusinessBankStatement24Mo") {
        docs.push("2-Year business bank statement")
      } else if (doc === "Form109924Mo") {
        docs.push("2-Year form 1099")
      } else if (doc === "Form109912Mo") {
        docs.push("1-Year form 1099")
      } else if (doc === "PL12") {
        docs.push("1-Year P & L")
      } else if (doc === "PL24") {
        docs.push("2-Year P & L")
      } else if (doc === "AssetUtilization") {
        docs.push("Asset utilization")
      } else if (doc === "DebtServiceCoverageRatio") {
        docs.push("DSCR")
      } else {
        docs.push(doc)
      }
    }
    return docs.join(", ")
  }

  const getDataSource = () => {
    let dataSource = props.showConnectedLendersOnly ? targetTab.outtabledata.filter(d => d.isConnected && props.selectedlenders.includes(d.program.split(" - ")[0])) : targetTab.outtabledata.filter(d => props.selectedlenders.includes(d.program.split(" - ")[0]))

    dataSource = dataSource.filter(d => {
      if (d.Lender === "Thunderbird") {
        return true
      } else {
        return d.IncomeDocTypes.some(type => props.selectedIncomeTypes.includes(type))
      }
    })
    console.log("final dataSource",dataSource)
    return dataSource
  }

  const handleShowAskAIModal = (record) => {
    if (record.Lender === "NewWaveLending") {
      if (record.Name.includes("DIP")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.NEW_WAVE_LENDING_DI_PRIME })
      } else if (record.Name.includes("DI)")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.NEW_WAVE_LENDING_DI })
      } else if (record.Name.includes("PNL")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.NEW_WAVE_LENDING_PL })
      } else if (record.Name.includes("VOE")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.NEW_WAVE_LENDING_VOE })
      } else if (record.Name.includes("EP")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.NEW_WAVE_LENDING_EP })
      }
    } else if (record.Lender === "NewFi") {
      if (record.Name.includes("EXPANDED NQM ITIN")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.NEWFI_NQMIEP })
      } else if (record.Name.includes("NQM ITIN")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.NEWFI_NQMIP })
      } else if (record.Name.includes("SEQUOIA DSCR")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.NEWFI_DSCR })
      } else if (record.Name.includes("SEQUOIA FOREIGN NATIONAL DSCR")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.NEWFI_FNDSCR })
      } else if (record.Name.includes("NQM")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.NEWFI_NQMP })
      }
    } else if (record.Lender === "amwest") {
      if (record.Name.includes("AAF")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.AMWEST_ADVANTAGE })
      } else if (record.Name.includes("AAI")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.AMWEST_AITIN })
      } else if (record.Name.includes("AAO")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.AMWEST_AONE })
      } else if (record.Name.includes("AAB")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.AMWEST_BK })
      } else if (record.Name.includes("AIA")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.AMWEST_INVESTOR })
      }  else if (record.Name.includes("AIP")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.AMWEST_INVESTOR_PLUS })
      } else if (record.Name.includes("AAQ")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.AMWEST_ASSETQ })
      }
    } else if (record.Lender === "ConstructiveCapital") {
      if (record.Name.includes("Standard")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.CONSTRUCTIVE_CAPITAL_STANDARD_DSCR })
      } else if (record.Name.includes("Expanded")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.CONSTRUCTIVE_CAPITAL_EXPANDED_DSCR })
      } 
    } else if (record.Lender === "AAA") {
      if (record.Name.includes("Prime No Doc")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.AAA_PRIME_NO_DOC })
      } else if (record.Name.includes("No Job No Income")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.AAA_NO_JOB_NO_INCOME })
      } else if (record.Name.includes("Self Prepared")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.AAA_SELF_PREPARED_PL })
      } else if (record.Name.includes("CPA Prepared")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.AAA_CPA_PREPARED_PL })
      } else if (record.Name.includes("DSCR Prime")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.AAA_DSCR_PRIME })
      } else if (record.Name.includes("DSCR")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.AAA_DSCR })
      } else if (record.Name.includes("Bank Statement")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.AAA_BANK_STATEMENT })
      } else if (record.Name.includes("Bridge Loan")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.AAA_BRIDGE_LOAN })
      } else if (record.Name.includes("Fix & Flip")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.AAA_FIX_FLIP })
      } else if (record.Name.includes("Prime CES")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.AAA_PRIME_CES })
      } else if (record.Name.includes("DSCR CES")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.AAA_DSCR_CES })
      } else if (record.Name.includes("Expanded HELOC")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.AAA_EXPANDED_HELOC })
      }
    } else if (record.Lender === "Thunderbird") {
      dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.THUNDERBIRD })
    } else if (record.Lender === "Greenbox") {
      if (record.Name.includes("CES") && record.Name.includes("DSCR")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.greenbox_ces_dscr })
      } else if (record.Name.includes("CES")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.greenbox_ces_fd_bs_pl })
      } else if (record.Name.includes("Combo95") && record.Name.includes("CES")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.greenbox_combo_ces_bs_fd })
      } else if (record.Name.includes("Combo95") && record.Name.includes("BS") && record.Name.includes("FD")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.greenbox_combo_bs_fd })
      } else if (record.Name.includes("2 to 8 Mix")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.greenbox_dscr_5_10_units_2_8_mix_use })
      } else if (record.Name.includes("Elite - DSCR")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.greenbox_elite_dscr })
      } else if (record.Name.includes("No Ratio - DSCR")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.greenbox_dscr_no_ratio })
      } else if (record.Name.includes("Elite Plus - DSCR")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.greenbox_elite_plus_dscr })
      } else if (record.Name.includes("Elite Plus - ")) { 
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.greenbox_elite_plus_bs_pl_fd })
      } else if (record.Name.includes("Elite") && record.Name.includes("WVOE")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.greenbox_elite_wvoe })
      } else if (record.Name.includes("Elite - ")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.greenbox_elite_bs_pl_fd_1099 })
      } else if (record.Name.includes("FN - Full Doc")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.greenbox_fn_fd })
      } else if (record.Name.includes("FN - DSCR")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.greenbox_fn_dscr_itin })
      } else if (record.Name.includes("ITIN") && record.Name.includes("BS")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.greenbox_itin_bs })
      } else if (record.Name.includes("ITIN") && record.Name.includes("Full Doc")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.greenbox_itin_fd })
      } else if (record.Name.includes("NP - ")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.greenbox_np_pl_fd })
      } else if (record.Name.includes("RH - ")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.greenbox_rh_bs_fd })
      } else if (record.Name.includes("Super Jumbo")) {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.greenbox_super_jumbo })
      }
    } else if (record.Lender === "Panther") {
      if (record.Name.includes("NOO") || record.Name.includes("2nd Home")) {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-panther_panther-agency-eligible-noo-2nd-home-matrix' })
      } else if (record.Name.includes("CORE Credit Guidelines")) {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-panther_panther-core-credit-guidelines' })
      } else {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-panther_panther-core-credit-matrix' })
      }
    } else if (record.Lender === "Willow") {
      if (record.Name.includes("Cash Flow")) {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-willow_willow-cash-flow-advantage' })
      } else if (record.Name.includes("Equity Advantage") && record.Name.includes("CES")) {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-willow_willow-equity-advantage-ces-eligibility' })
      } else if (record.Name.includes("Equity Advantage")) {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-willow_willow-equity-advantage' })
      } else if (record.Name.includes("Investor Advantage") && record.Name.includes("Eligibility")) {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-willow_willow-investor-advantage-eligibility' })
      } else if (record.Name.includes("Investor Advantage")) {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-willow_willow-investor-advantage' })
      } else if (record.Name.includes("Non Agency") && record.Name.includes("Guidelines")) {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-willow_willow-non-agency-guidelines' })
      } else if (record.Name.includes("Non Agency")) {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-willow_willow-non-agency-advantage' })
      } else if (record.Name.includes("Professional Investor")) {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-willow_willow-professional-investor' })
      } else if (record.Name.includes("Summary") || record.Name.includes("Matrix")) {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-willow_willow-summary-program-matrix' })
      } else if (record.Name.includes("Super Jumbo")) {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-willow_willow-super-jumbo' })
      } else if (record.Name.includes("Titanium")) {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-willow_willow-titanium-advantage' })
      } else {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-willow_willow-summary-program-matrix' })
      }
    } else if (record.Lender === "Pebbles") {
      dispatch({ type: 'CHANGE_PDF', data: 'googain-pebbles_pebbles-delegated-nonqm-matrix' })
    } else if (record.Lender === "Bahamas") {
      if (record.Name.includes("Equity Solutions") && record.Name.includes("Guidelines")) {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-bahamas_bahamas-loan-eligibility-guidelines-equity-solutions' })
      } else if (record.Name.includes("Equity Solutions") && record.Name.includes("Matrix")) {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-bahamas_bahamas-matrix-equity-solutions' })
      } else if (record.Name.includes("Guidelines")) {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-bahamas_bahamas-loan-eligibility-guidelines' })
      } else {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-bahamas_bahamas-matrix' })
      }
    } else if (record.Lender === "Glory") {
      if (record.Name.includes("2nd Lien")) {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-glory_glory-2nd-lien-guidelines' })
      } else if (record.Name.includes("NQM")) {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-glory_glory-nqm' })
      } else if (record.Name.includes("QM") || record.Name.includes("AUS")) {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-glory_glory-qm-aus' })
      } else {
        dispatch({ type: 'CHANGE_PDF', data: 'googain-glory_glory-nqm' })
      }
    }
    dispatch({ type: 'SHOW_PDF', data: false })
    setShowAskAIModal(true)
  }

  const displayAskAIModal = () => {
    return (
      <FullScreenModal
        open={showAskAIModal}
        onClose={()=>{
          setShowAskAIModal(false)
          dispatch({ type: 'SHOW_PDF', data: true })
        }}
        centered
        footer={[
          <Button key="back" onClick={() => {
            setShowAskAIModal(false)
            dispatch({ type: 'SHOW_PDF', data: true })
          }}>
            Cancel
          </Button>,
        ]}
        content={<MortgageGPT hideBackButton={true} />}
        wrapClassName="nonqm-calculator-modal"
      >
      </FullScreenModal>
    )
  }

  return (
    <div className="text-left w-100" style={{height:"90%"}}>
      {displayAskAIModal()}
      <div className="d-flex justify-content-end  align-items-center my-2" >
        {selectedRows.length >0 && <Button type="primary" className="mr-2" onClick={()=>setShowShareRatesModal(true)}>Share</Button>}
      </div>
      {props.eligibilityView!=="ineligible" && <div style={{marginRight:"5px",textAlign:"right",color:"#6E6E70", fontSize:"12px", fontWeight:"500"}}>*Search will return lowest rate at which target price first occurs</div>}
      {props.eligibilityView === "ineligible"?
        <Table
          style={{width:"100%"}}
          className="ineligibletable"
          pagination={false}
          columns={ineligiblecolumns}
          rowClassName="ineligibleRow"
          dataSource={ineligibles}
          locale={{emptyText: <div style={{color:"#6E6E70"}}>{'No matched reason'}</div>}}
          scroll={{
            y: checkAccess((UR_PriceEngineUser)) ? props.viewportH- 280 : props.viewportH*0.75
          }}
        />
      :
        <Table
          style={{width:"100%"}}
          className="outertable"
          dataSource={getDataSource()}
          pagination={false}
          columns={maincolumns}
          locale={{
            emptyText: <div style={{color:"#6E6E70"}}>
              {'No matched products, please check the ineligible reasons.'}
              <div>
                <Button type="primary" className="mt-2" onClick={()=>props.setIneligibleView("ineligible")}>Check reasons</Button>
              </div>
              </div>
          }}
          scroll={{
            y: checkAccess((UR_PriceEngineUser)) ? props.viewportH- 280 : props.viewportH*0.75
          }}
          rowClassName={(record,_)=> record.isConnected ? "connectedLenderRow":"unconnectedLenderRow"}
          showSorterTooltip={false}
          expandable={{
            expandedRowRender: (record) => (
              <div>
                {/* {!record.isConnected && <div className="notAddedLenderLabel"><Tooltip className="d-flex align-items-center" title="This wholesale lender is not currently added to your list of lenders. To connect with this lender, click the + button."> Not added yet <QuestionCircleOutlined style={{color:"#fffff", marginLeft:5}} />  </Tooltip></div>} */}
                <div >
                  <Row gutter={20}>
                    <Col lg={8} span={24} style={{marginBottom: 12}}>
                      <div className="productDetails rate-lender-card">
                        <div style={{fontSize:"14px",color:"#586570", lineHeight: 'normal', fontWeight: 600}}>Loan summary</div>
                        <div className="rate-lender-card-item d-flex justify-content-between">
                              <div>Loan amount:</div>
                              <div>${commaizeFloat(record.loanAmount)}</div>
                        </div>
                        <div className="rate-lender-card-item d-flex justify-content-between">
                              <div>Loan term:</div>
                              <div>{(props.loanterm).toUpperCase()}</div>
                        </div>
                        <div className="rate-lender-card-item d-flex justify-content-between">
                              <div>LTV:</div>
                              <div>{props.loanInfo.ltv[0]}%</div>
                        </div>
                        <div className="rate-lender-card-item d-flex justify-content-between">
                              <div>FICO:</div>
                              <div>{props.loanInfo.fico}</div>
                        </div>
                        <div className="rate-lender-card-item d-flex justify-content-between">
                              <div>Escrow:</div>
                              <div>{props.loanInfo.escrow===true?"NO":"YES"}</div>
                        </div>
                        <div className="rate-lender-card-item d-flex justify-content-between">
                              <div>Lender origination fee:</div>
                              <div>${record.lender_fee}</div>
                        </div>
                      </div>
                    </Col>
                    
                    <Col lg={16} span={24} style={{marginBottom: 12}}>
                      <div className="productDetails rate-lender-card">
                        <div className="d-flex justify-content-between" style={{fontSize:"14px",color:"#586570", lineHeight: 'normal', fontWeight: 600}}>
                          <div>About this product</div>
                          {/* <Button type="link" onClick={()=>handleShowAskAIModal(record)}>Guideline</Button> */}
                        </div>
                        <Row style={{ flex: 1 }}>
                          <Col lg={12} span={24}>
                            <div style={{borderRight:"1px solid #CFD4D9",paddingRight: 18, height: '100%', display: 'flex', flexDirection: 'column', gap: 10}}>
                              <div className="rate-lender-card-item d-flex justify-content-between">
                                    <div>Income documentation</div>
                                    <div style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                      <Tooltip title={mapIncomeDocType(record.IncomeDocTypes)}>
                                        {mapIncomeDocType(record.IncomeDocTypes)}
                                      </Tooltip>
                                    </div>
                              </div>
                              <div className="rate-lender-card-item d-flex justify-content-between">
                                    <div>Lender</div>
                                    <div>{com.formatLenderDisplayName(record.Lender)}</div>
                              </div>
                              <div className="rate-lender-card-item d-flex justify-content-between">
                                    <div>Product name</div>
                                    <div>{record.Name}</div>
                              </div>
                              <div className="rate-lender-card-item d-flex justify-content-between ">
                                    <div>Underwriting</div>
                                    <div>{record.Aus.join("/")}</div>
                              </div>
                              {typeof record.pricedetails.adjustmentPoint === "number" && record.pricedetails.adjustmentPoint !== 0 && (
                                <div className="rate-lender-card-item d-flex justify-content-between">
                                  <div>Applied adjustments</div>
                                  <div>{record.pricedetails.adjustmentPoint.toFixed(3)}%</div>
                                </div>
                              )}
                              {getMaxPriceCap(record).hasMaxPriceCap && (
                                <div className="rate-lender-card-item d-flex justify-content-between">
                                  <div>Max Price</div>
                                  <div>{getMaxPriceCap(record).capPoints.toFixed(3)}%</div>
                                </div>
                              )}
                              {
                                record.Adjustments && Object.keys(record.Adjustments).length > 0 && Object.entries(record.Adjustments).map(([key, value]) => (
                                  <div className="rate-lender-card-item d-flex justify-content-between" style={{color:"#6E6E70"}}>
                                    <div>{key}</div>
                                    <div>{value}%</div>
                                  </div>
                                ))
                              }
                            </div>
                          </Col>

                          <Col lg={12} span={24}>
                              <div style={{paddingLeft: 18, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                                <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
                                  <div className="rate-lender-card-item d-flex justify-content-between">
                                      <div>Lock day:</div>
                                      <div>{record.lockDay}</div>
                                  </div>
                                </div>
                                <div style={{fontSize: 12, color: '#6E6E70', textAlign: 'right'}}>*Last Updated on {getCurrentDate()} 09:00</div>
                              </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>

                  {/* Closing Cost Details Section */}
                  <Row gutter={20} style={{marginTop: 16}}>
                    <Col span={24}>
                      <div className="raw-detail-card">
                        <div className="raw-detail-card-title">
                          <span>Closing cost details</span> 
                          <span className="closing-cost-details-view-fee-sheet" 
                                onClick={() => {
                                  setSelectedLoanForModal(record);
                                  setShowClosingCostModal(true);
                                  setUpdatedOriginationArr(AppendOriginationInfoForThunderbird(record))
                                }}>
                            View fee sheet
                          </span>
                        </div>

                        {(() => {
                          const costs = getClosingCostDetails(record.lender_fee, record.Lender, record.prices.compensationPoint*record.loanAmount*0.01);
                          return (
                            <>
                              <div className="raw-detail-card-content-type">Loan costs</div>
                                <div className="raw-detail-card-content-row">
                                  <div className="raw-detail-card-content-label">A. Origination Charges</div>
                                  <div className="raw-detail-card-content-value">$ {com.commaizeFloat(costs.originationCharges)}</div>
                                </div>
                              <div className="raw-detail-card-content-row">
                                <div className="raw-detail-card-content-label">B. Services CANNOT shop for</div>
                                <div className="raw-detail-card-content-value">$ {com.commaizeFloat(costs.canNotShopServices)}</div>
                              </div>
                              <div className="raw-detail-card-content-row">
                                <div className="raw-detail-card-content-label">C. Services CAN shop for</div>
                                <div className="raw-detail-card-content-value">$ {com.commaizeFloat(costs.canShopServices)}</div>
                              </div>
                              <div className="raw-detail-card-content-row">
                                <div className="raw-detail-card-content-label">D. Total Loan Costs (A + B + C)</div>
                                <div className="raw-detail-card-content-value">$ {com.commaizeFloat(costs.totalLoanCosts)}</div>
                              </div>

                              <div className="raw-detail-card-content-type">Other costs</div>
                              <div className="raw-detail-card-content-row">
                                <div className="raw-detail-card-content-label">E. Taxes and Other Government Fees</div>
                                <div className="raw-detail-card-content-value">$ {com.commaizeFloat(costs.taxesAndOtherGovernmentFees)}</div>
                              </div>
                              <div className="raw-detail-card-content-row">
                                <div className="raw-detail-card-content-label">F. Prepaids</div>
                                <div className="raw-detail-card-content-value">$ {com.commaizeFloat(costs.prepaids)}</div>
                              </div>
                              <div className="raw-detail-card-content-row">
                                <div className="raw-detail-card-content-label">G. Initial Escrow Payment at Closing</div>
                                <div className="raw-detail-card-content-value">$ {com.commaizeFloat(costs.initialEscrowPaymentsAtClosing)}</div>
                              </div>
                              {costs.other > 0 && (
                                <div className="raw-detail-card-content-row">
                                  <div className="raw-detail-card-content-label">H. Other Costs</div>
                                  <div className="raw-detail-card-content-value">$ {com.commaizeFloat(costs.other)}</div>
                                </div>
                              )}
                              <div className="raw-detail-card-content-row" style={{borderTop: '1px solid #CFD4D9', marginTop: 8, paddingTop: 8}}>
                                <div className="raw-detail-card-content-label" style={{fontWeight: 600, color: '#222'}}>Total Other Costs (E + F + G{costs.other > 0 ? ' + H' : ''})</div>
                                <div className="raw-detail-card-content-value" style={{fontWeight: 600, color: '#222'}}>$ {com.commaizeFloat(costs.totalOtherCosts)}</div>
                              </div>
                              <div className="raw-detail-card-content-row" style={{borderTop: '1px solid #CFD4D9', marginTop: 8, paddingTop: 8}}>
                                <div className="raw-detail-card-content-label" style={{fontWeight: 600, color: '#222'}}>Total Closing Costs (D + Other)</div>
                                <div className="raw-detail-card-content-value" style={{fontWeight: 600, color: '#222'}}>$ {com.commaizeFloat(costs.totalClosingCosts)}</div>
                              </div>
                            </>
                          );
                        })()}
                      </div>
                    </Col>
                  </Row>

                  <div className="justify-content-center">
                    <Table 
                      className="innertable"
                      pagination={false}
                      showHeader={true}
                      columns={innerColumns}
                      dataSource={targetTab.intabledata[record.program]}
                      rowClassName="innerTableRow"
                      />
                  </div>
                </div>
              </div>
            ),
            rowExpandable: record => true,
            expandIcon:({expanded,onExpand, record})=>{
              return(
                  expanded? (
                      <img
                        src="/images/priceengine/lendersUpIcon.png"
                        style={{cursor: "pointer", width:32}} 
                        onClick={(e)=>{
                          onExpand(record,e)
                        }}
                      />
                  ):(
                    <img
                    src="/images/priceengine/lendersDownIcon.png"
                      style={{cursor: "pointer", width:32}} 
                        onClick={(e)=>{
                          onExpand(record,e)
                        }}
                      />
                  )
                  
              )
            }
          }}
        />
      }

    <Modal
      open={showAddLenderModal}
      onCancel={()=>setShowAddLendersModal(false)}
      centered
      footer={[
        <Button key="back" onClick={()=>setShowAddLendersModal(false)}>
          Cancel
        </Button>,
      ]}
      width={1000}
    >
      <Lenders />
    </Modal>
    <Modal
      title="Share Rates"
      open={showShareRateModal}
      onCancel={()=>setShowShareRatesModal(false)}
      centered
      footer={[
        <Button type="primary" onClick={()=>setShowShareRatesModal(false)}>
          Share
        </Button>,
      ]}
    >
      <div className="p-3">
        <div className="title-5">Borrower Email</div>
        <Input placeholder="email@example.com"/>

        <div className="title-5">Selected rates</div>
        {/* {displaySelectedRates(selectedRows)} */}
        
        <div className="title-5">Additonal information (optional)</div>
        <TextArea rows={4} placeholder="Enter your infomation..." maxLength={6} />


      </div>
    
    </Modal>

    <ClosingCostFeeModal 
      show={showClosingCostModal}
      onHide={() => setShowClosingCostModal(false)}
      filterParams={props.loanInfo}
      selectedLoan={selectedLoanForModal ? {
        ...selectedLoanForModal,
        loanAmount: selectedLoanForModal.loanAmount || props.loanInfo?.loanAmount,
        estimatedclosingcosts: props.closingFeeConfig
      } : null}
      detailedCard={selectedLoanForModal ? {
        ...selectedLoanForModal,
        closing_costs_detail: null,
        loanAmount: selectedLoanForModal.loanAmount || props.loanInfo?.loanAmount
      } : null}
      closingCostsDetail={
        {
          ...props.closingFeeConfig,
          originationCharges: updatedOriginationArr
        }
      }
      detailType="all"
    />

    {/* Furute TODO: render the modal content based on the lender's referal introduction set up data  */}
    <ReferModal
      isOpen={showReferModal}
      onCancel={()=>setShowReferModal(false)}
      onConfirm={()=> window.open("https://trythunderbird.com/broker-register?utm_source=zeitro", "_blank")}
      title="Sign up with Thunderbird"
      contactName="Thunderbird Account Representative"
      contactEmail="zeitro@trythunderbird.com"
      contactPhone="(646)914-7021"
      description="Thank you for your interest in registering your loan with Thunderbird. Click the link below to initiate loan registration through our Portal. Please contact your AE with any questions."
      confirmText="Sign up now"
      confirmButtonType="primary"
    />

    </div>
  );
}



